var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Ver Historial De Estados")]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c("v-flex", { attrs: { md12: "" } }, [
                                      _c(
                                        "h2",
                                        {
                                          staticClass: "h2_title",
                                          staticStyle: {
                                            "margin-top": "12px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Ver Historial De Estados De La Alarma:\n                      " +
                                              _vm._s("" + _vm.alarmaNombre) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _c("v-divider"),
                                _c("br"),
                                _c(
                                  "v-layout",
                                  { attrs: { wrap: "" } },
                                  [
                                    _c("MantenedorGrid", {
                                      staticClass: "ag-theme-material",
                                      staticStyle: {
                                        width: "100%",
                                        height: "auto",
                                        "font-family": "'Asap' sans-serif"
                                      },
                                      attrs: { gridOptions: _vm.gridOptions }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }